export class WlShareEvent extends Event {

    static type: string = 'wl-share-clicked';

    constructor() {
        super(WlShareEvent.type, {bubbles: true, composed: true});
    }
}